module.exports = __webpack_public_path__ + "img/2.b5f4c60f.png";